import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'api/axios';

const initialState = {
	currentOpenDrawer: '',
	message: '',
	mainserviceCategoryId: '',
	subCategoryId: '',
	mainServiceCategories: [],
	serviceynamicFields: [],
	serviceSubCategory: [],
	isLoading: false,
	drawarLoading: false,
	pagination: {
		page: 1,
		limit: 10,
		totalPages: 0,
		totalResults: 0,
	},
	drawerValues: {
		CREATE_DYNAMIC_FIELD: 'CREATE_DYNAMIC_FIELD',
		UPDATE_DYNAMIC_FIELD: 'UPDATE_DYNAMIC_FIELD',
		FILTER_DYNAMIC_FIELD: 'FILTER_DYNAMIC_FIELD',
		VIEW_DYNAMIC_FIELD: 'VIEW_DYNAMIC_FIELD',
	},
};

// Product Main Category CRUD
export const getAllMainServiceCategories = createAsyncThunk('serviceCategory/getAllMainServiceCategories', async (options, { rejectWithValue }) => {
	try {
		const query = new URLSearchParams(options).toString();

		console.log(query, 'query...');

		const response = await axiosInstance.get(`/service-category/admin?${query}`);
		if (response.success) {
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const addNewMaincategory = createAsyncThunk('serviceCategory/addNewMaincategory', async (data, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.post(`/service-category`, data);
		console.log(response, 'response');

		if (response.success) {
			const { serviceCategory } = getState();

			const options = {
				page: serviceCategory.pagination.page,
				limit: serviceCategory.pagination.limit,
			};

			dispatch(getAllMainServiceCategories(options));
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const deleteMainCategory = createAsyncThunk('serviceCategory/deleteMainCategory', async (id, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.delete(`/service-category/${id}`);

		if (response.success) {
			const { serviceCategory } = getState();

			const options = {
				page: serviceCategory.pagination.page,
				limit: serviceCategory.pagination.limit,
			};

			dispatch(getAllMainServiceCategories(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const updateMainCategory = createAsyncThunk('serviceCategory/updateMainCategory', async ({ id, data }, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.patch(`/service-category/${id}`, data);

		if (response.success) {
			const { serviceCategory } = getState();

			const options = {
				page: serviceCategory.pagination.page,
				limit: serviceCategory.pagination.limit,
			};

			dispatch(getAllMainServiceCategories(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

// Product Sub Category CRUD
export const getAllSubServiceCategories = createAsyncThunk('serviceCategory/getAllSubServiceCategories', async (options, { rejectWithValue }) => {
	try {
		const query = new URLSearchParams(options).toString();

		const response = await axiosInstance.get(`/service-subcategory/admin?${query}`);
		if (response.success) {
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const createSubCategory = createAsyncThunk('serviceCategory/createNewSubCategory', async (data, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.post(`/service-subcategory`, data);

		if (response.success) {
			const { serviceCategory } = getState();

			const options = {
				categoryId: serviceCategory.mainserviceCategoryId,
				page: serviceCategory.pagination.page,
				limit: serviceCategory.pagination.limit,
			};

			dispatch(getAllSubServiceCategories(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const updateSubCategory = createAsyncThunk('serviceCategory/updateSubCategory', async ({ id, data }, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.patch(`/service-subcategory/${id}`, data);

		if (response.success) {
			const { serviceCategory } = getState();

			const options = {
				categoryId: serviceCategory.mainserviceCategoryId,
				page: serviceCategory.pagination.page,
				limit: serviceCategory.pagination.limit,
			};

			dispatch(getAllSubServiceCategories(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const deleteSubCategory = createAsyncThunk('serviceCategory/deleteSubCategory', async (id, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.delete(`/service-subcategory/${id}`);

		if (response.success) {
			const { serviceCategory } = getState();

			const options = {
				categoryId: serviceCategory.mainserviceCategoryId,
				page: serviceCategory.pagination.page,
				limit: serviceCategory.pagination.limit,
			};

			dispatch(getAllSubServiceCategories(options));
			return response;
		}
	} catch (error) {
		console.error(error.response, 'ERR...');
		return rejectWithValue(error.response || 'Error');
	}
});

// Product Dynamic Fields CRUD

export const getAllDynamicFields = createAsyncThunk('serviceCategory/getAllDynamicFields', async (options, { rejectWithValue }) => {
	try {
		const query = new URLSearchParams(options).toString();

		const response = await axiosInstance.get(`/service-category-fields/admin?${query}`);
		if (response.success) {
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);

		return rejectWithValue(error.response || {});
	}
});

export const createProductDynamicField = createAsyncThunk('serviceCategory/createProductDynamicField', async (data, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.post(`/service-category-fields`, data);

		if (response.success) {
			const { serviceCategory } = getState();

			const options = {
				categoryId: serviceCategory.mainserviceCategoryId,
				subCategoryId: serviceCategory.subCategoryId,
				allRecords: true,
				page: serviceCategory.pagination.page,
				limit: serviceCategory.pagination.limit,
			};

			dispatch(updateDrawerView(''));
			dispatch(getAllDynamicFields(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const updateDynamicField = createAsyncThunk('serviceCategory/updateDynamicField', async ({ id, data }, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.patch(`/service-category-fields/${id}`, data);

		if (response.success) {
			const { serviceCategory } = getState();

			const options = {
				categoryId: serviceCategory.mainserviceCategoryId,
				subCategoryId: serviceCategory.subCategoryId,
				allRecords: true,
				page: serviceCategory.pagination.page,
				limit: serviceCategory.pagination.limit,
			};

			dispatch(updateDrawerView(''));
			dispatch(getAllDynamicFields(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const deleteDynamicField = createAsyncThunk('serviceCategory/deleteDynamicField', async (id, { rejectWithValue, dispatch, getState }) => {
	try {
		const response = await axiosInstance.delete(`/service-category-fields/${id}`);

		if (response.success) {
			const { serviceCategory } = getState();

			const options = {
				categoryId: serviceCategory.mainserviceCategoryId,
				subCategoryId: serviceCategory.subCategoryId,
				allRecords: true,
				page: serviceCategory.pagination.page,
				limit: serviceCategory.pagination.limit,
			};

			dispatch(getAllDynamicFields(options));
			return response;
		}
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response || {});
	}
});

export const serviceCategorySlice = createSlice({
	name: 'serviceCategory',
	initialState: initialState,
	reducers: {
		setLoading: (state, action) => {
			state.isLoading = action.payload;
		},
		updatePagination: (state, action) => {
			state.pagination = {
				...state.pagination,
			};
		},
		setMainServiceCategoryId: (state, action) => {
			state.mainserviceCategoryId = action.payload;
		},
		setSubCategoryId: (state, action) => {
			state.subCategoryId = action.payload;
		},
		updateDrawerView: (state, action) => {
			state.currentOpenDrawer = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getAllMainServiceCategories.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(getAllMainServiceCategories.fulfilled, (state, { payload }) => {
				state.mainServiceCategories = payload.result.data;
				state.message = payload.message;
				state.isLoading = false;
				state.pagination = {
					page: payload.result.page,
					limit: payload.result.limit,
					totalPages: payload.result.totalPages,
					totalResults: payload.result.totalResults,
				};
			})
			.addCase(getAllMainServiceCategories.rejected, (state, { payload }) => {
				state.mainServiceCategories = [];
				state.message = '';
				state.isLoading = false;
			})
			.addCase(addNewMaincategory.pending, (state, { payload }) => {
				state.drawarLoading = true;
			})
			.addCase(addNewMaincategory.fulfilled, (state, { payload }) => {
				state.drawarLoading = false;
				state.message = payload.message;
			})
			.addCase(addNewMaincategory.rejected, (state, { payload }) => {
				state.drawarLoading = false;
				state.message = payload.message;
			})
			.addCase(deleteMainCategory.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(deleteMainCategory.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(deleteMainCategory.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(updateMainCategory.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(updateMainCategory.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(updateMainCategory.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(getAllSubServiceCategories.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(getAllSubServiceCategories.fulfilled, (state, { payload }) => {
				state.serviceSubCategory = payload.result.data;
				state.message = payload.message;
				state.isLoading = false;
				state.pagination = {
					page: payload.result.page,
					limit: payload.result.limit,
					totalPages: payload.result.totalPages,
					totalResults: payload.result.totalResults,
				};
			})
			.addCase(getAllSubServiceCategories.rejected, (state, { payload }) => {
				state.serviceSubCategory = [];
				state.message = '';
				state.isLoading = false;
			})
			.addCase(deleteSubCategory.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(deleteSubCategory.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(deleteSubCategory.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(createSubCategory.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(createSubCategory.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(createSubCategory.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(createProductDynamicField.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(createProductDynamicField.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(createProductDynamicField.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(getAllDynamicFields.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(getAllDynamicFields.fulfilled, (state, { payload }) => {
				state.serviceynamicFields = payload.result.data;
				state.message = payload.message;
				state.isLoading = false;
				state.pagination = {
					page: payload.result.page,
					limit: payload.result.limit,
					totalPages: payload.result.totalPages,
					totalResults: payload.result.totalResults,
				};
			})
			.addCase(getAllDynamicFields.rejected, (state, { payload }) => {
				state.serviceynamicFields = [];
				state.message = '';
				state.isLoading = false;
			})
			.addCase(deleteDynamicField.pending, (state, { payload }) => {
				state.isLoading = true;
			})
			.addCase(deleteDynamicField.fulfilled, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			})
			.addCase(deleteDynamicField.rejected, (state, { payload }) => {
				state.isLoading = false;
				state.message = payload.message;
			});
	},
});

export const { updatePagination, setMainServiceCategoryId, setSubCategoryId, updateDrawerView } = serviceCategorySlice.actions;

export default serviceCategorySlice.reducer;
